import { isNull } from "lodash";
export const transformPhoneNumber = (phoneNumber: string) => {
  if (isNull(phoneNumber)) {
    return {
      isValid: false,
      error: "Phone number can not be empty",
    };
  }

  if (!/^4[\d]{8}/g.test(phoneNumber)) {
    return {
      isValid: false,
      error: "Please input a valid phone number(without '0' prefix)",
    };
  }

  return {
    isValid: true,
    formattedValue: `+61${phoneNumber}`,
  };
};
